export const gutter = 8; // px

// TODO Waiting responsitive
export const minSiteWidth = '1280px';
export const maxSiteWidth = '1280px';

export const fontSizeBase = '15px';
export const fontSizeSmall = '12px';
